module.exports = __webpack_public_path__ + "static/logo27-2581726f2f26a7a1817b1cffd002bc97.png";